import styled from "styled-components";

export const ContentGrid = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1.35fr) minmax(320px, 0.85fr);
    gap: 22px;
    align-items: start;

    @media (max-width: 900px) {
        grid-template-columns: 1fr;
    }
`;

export const EditorPanel = styled.section`
    padding: 22px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background: #ffffff;
`;

export const FieldGroup = styled.div`
    margin-bottom: 18px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const Label = styled.label`
    display: block;
    margin-bottom: 8px;
    color: #1f2937;
    font-size: 0.9rem;
    font-weight: 700;
`;

export const Input = styled.input`
    width: 100%;
    min-height: 42px;
    padding: 0 12px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    color: #111827;
    font-size: 0.95rem;

    &:focus {
        outline: none;
        border-color: #9333ea;
        box-shadow: 0 0 0 3px rgba(147, 51, 234, 0.12);
    }
`;

export const Textarea = styled.textarea`
    width: 100%;
    padding: 12px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    color: #111827;
    font-size: 0.95rem;
    line-height: 1.5;
    resize: vertical;

    &:focus {
        outline: none;
        border-color: #9333ea;
        box-shadow: 0 0 0 3px rgba(147, 51, 234, 0.12);
    }
`;

export const Hint = styled.p`
    margin: 7px 0 0;
    color: #6b7280;
    font-size: 0.8rem;
`;

export const PreviewPanel = styled.aside`
    padding: 22px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background: #ffffff;
`;

export const PreviewHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
    color: #374151;
    font-weight: 700;
`;
